// @flow

import { useEffect, useState } from "react";
import { useQuery } from "@apollo/client/react/hooks";
import { useLocation } from "react-router";
import qs from "query-string";
import {
  POSTCODE_DETAILS,
  ADDRESS_NOT_FOUND_ID,
} from "@nested/brand/src/components/AddressPicker/AddressPicker";

export const usePrefilledAddress = (allowAddressNotFound: boolean) => {
  const location = useLocation();
  const { addressId, postcode } = qs.parse(location.search);

  const addressNotFound = addressId === ADDRESS_NOT_FOUND_ID;
  const invalidInput =
    !addressId || !postcode || (addressNotFound && !allowAddressNotFound);

  const [address, setAddress] = useState();
  const [hasError, setHasError] = useState(invalidInput);
  const { data, loading, error } = useQuery(POSTCODE_DETAILS, {
    variables: {
      postcode,
      includeBlacklisted: true,
    },
    skip: invalidInput,
  });

  useEffect(() => {
    if (loading || invalidInput) return;
    if (error) {
      setHasError(true);
      return;
    }

    const {
      postcodeDetails: { addresses, blacklisted, inServicedArea },
    } = data;

    if (addressNotFound) {
      setAddress({
        id: ADDRESS_NOT_FOUND_ID,
        blacklisted,
        postcodeInServicedArea: inServicedArea,
        postcode,
      });
    }

    const selectedAddress = addresses.find((a) => a.id === addressId);
    if (selectedAddress) {
      setAddress({
        ...selectedAddress,
        blacklisted,
        postcodeInServicedArea: inServicedArea,
      });
    } else {
      setHasError(true);
    }
  }, [loading]);

  return {
    loading,
    address,
    error: hasError,
  };
};
